(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-information"]) return;
  try {
    
(() => {
  const initProductDescriptions = (root = document) => {
    root
      .querySelectorAll(
        '.product-information .product-details .text-block.rte:not([data-umlg-more-ready])'
      )
      .forEach((description) => {
        description.dataset.umlgMoreReady = 'true';

        const content = description.querySelector('rte-formatter') || description;
        content.classList.add('umlg-description--collapsed');

        requestAnimationFrame(() => {
          if (content.scrollHeight <= content.clientHeight + 2) {
            content.classList.remove('umlg-description--collapsed');
            return;
          }

          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'umlg-description-toggle';
          button.textContent = 'MORE';
          button.setAttribute('aria-expanded', 'false');

          button.addEventListener('click', () => {
            const expanded = button.getAttribute('aria-expanded') === 'true';

            button.setAttribute('aria-expanded', String(!expanded));
            content.classList.toggle('umlg-description--collapsed', expanded);
            button.textContent = expanded ? 'MORE' : 'LESS';
          });

          description.insertAdjacentElement('afterend', button);
        });
      });
  };

  initProductDescriptions();

  document.addEventListener('shopify:section:load', (event) => {
    initProductDescriptions(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
